import { FileCheck2, KeyRound, Lock, ShieldCheck } from "lucide-react";
import { useI18n } from "../i18n";
import { Reveal } from "./reveal";

/** Segurança — a única faixa escura do site: papel dá lugar à tinta. */
export function Security() {
  const { t } = useI18n();
  const selos = [
    { icon: ShieldCheck, label: t("seg.s1") },
    { icon: Lock, label: t("seg.s2") },
    { icon: KeyRound, label: t("seg.s3") },
    { icon: FileCheck2, label: t("seg.s4") },
  ];

  return (
    <section id="seguranca" className="relative scroll-mt-24 bg-ink py-24 text-paper-on-ink sm:py-32">
      <div className="relative mx-auto max-w-6xl px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <div className="flex flex-col items-start gap-5">
            <Reveal>
              <p className="flex items-center gap-2.5 font-mono text-[11px] font-medium tracking-[0.16em] uppercase">
                <span className="text-paper-on-ink/40">05</span>
                <span aria-hidden className="h-px w-6 bg-paper-on-ink/25" />
                <span className="text-amber-mark">{t("seg.rotulo")}</span>
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-[clamp(1.9rem,4.5vw,3rem)] leading-[1.08] font-semibold tracking-[-0.02em] text-balance">
                {t("seg.titulo")}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="max-w-lg text-base leading-relaxed text-paper-on-ink/65 sm:text-lg text-pretty">
                {t("seg.desc")}
              </p>
            </Reveal>
          </div>

          <div className="grid border-t border-l border-white/[0.12] sm:grid-cols-2">
            {selos.map((s, i) => (
              <Reveal key={s.label} delay={0.08 + i * 0.05} className="h-full">
                <div className="group flex h-full items-center gap-3.5 border-r border-b border-white/[0.12] px-5 py-6 transition-colors duration-300 hover:bg-white/[0.04]">
                  <span className="grid size-10 shrink-0 place-items-center rounded-lg bg-white/[0.08] text-amber-mark">
                    <s.icon className="size-[18px]" strokeWidth={1.8} />
                  </span>
                  <p className="text-sm leading-snug font-medium text-paper-on-ink/90">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
